import RHDashboard from "views/Rh/RhDashboard";
import LeaveApprovals from "views/Rh/LeaveApprovals";
import AttendanceOverview from "views/Rh/AttendanceOverview";
import MyLeaveRequests from "views/Rh/MyLeaveRequests";
//hh
const rhRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "ni ni-tv-2",
    component: <RHDashboard />,
    layout: "/rh",
    sidebar: true,
  },
  {
    path: "/leave-approvals",
    name: "Leave Approvals",
    icon: "ni ni-check-bold",
    component: <LeaveApprovals />,
    layout: "/rh",
    sidebar: true,
  },
  {
    path: "/attendance",
    name: "Attendance",
    icon: "ni ni-time-alarm",
    component: <AttendanceOverview />,
    layout: "/rh",
    sidebar: true,
  },
  {
    path: "/my-leaves",
    name: "My Leave Requests",
    icon: "ni ni-calendar-grid-58",
    component: <MyLeaveRequests />,
    layout: "/rh",
    sidebar: true,
  },
];

export default rhRoutes;